export const WORKSPACE_URL_PATTERN = '/workspace/:workspaceId';

export const DISPLAY_ID_PARAM = ':displayId';
export const GROUP_ID_PARAM = ':displayGroupId';
export const PLAYLIST_ID_PARAM = ':playlistId';
export const WORKSPACE_ID_PARAM = ':workspaceId';

export const NEW_SUB_PATH = '/new';

export const DISPLAY_SUB_PATH = '/displays';
export const DISPLAY_LIST_PAGE_URL = `${WORKSPACE_URL_PATTERN}${DISPLAY_SUB_PATH}`;
export const DISPLAY_URL = `${WORKSPACE_URL_PATTERN}${DISPLAY_SUB_PATH}/${DISPLAY_ID_PARAM}`;

export const DISPLAY_IN_GROUP_SUB_PATH = `/group/${GROUP_ID_PARAM}/display/${DISPLAY_ID_PARAM}`;
export const DISPLAY_IN_GROUP_URL = `${WORKSPACE_URL_PATTERN}${DISPLAY_SUB_PATH}${DISPLAY_IN_GROUP_SUB_PATH}`;

export const LED_STRIPS_SUB_PATH = '/led-strips'
export const LED_STRIPS_PAGE_URL = `${WORKSPACE_URL_PATTERN}${LED_STRIPS_SUB_PATH}`

export const GROUP_PAGE_SUB_PATH = `/group/${GROUP_ID_PARAM}`;
export const GROUP_PAGE_URL = `${WORKSPACE_URL_PATTERN}${DISPLAY_SUB_PATH}${GROUP_PAGE_SUB_PATH}`;

export const PLAYERLIST_SUB_PATH = '/playlists';
export const PLAYLIST_PAGE_URL = `${WORKSPACE_URL_PATTERN}${PLAYERLIST_SUB_PATH}`;
export const PLAYLIST_URL = `${WORKSPACE_URL_PATTERN}${PLAYERLIST_SUB_PATH}/${PLAYLIST_ID_PARAM}`;
export const NEW_PLAYLIST_URL = `${WORKSPACE_URL_PATTERN}${PLAYERLIST_SUB_PATH}${NEW_SUB_PATH}`;

export const PLAYBOOK_SUB_PATH = '/playbook';
export const PLAYBOOK_PAGE_URL = `${WORKSPACE_URL_PATTERN}${PLAYBOOK_SUB_PATH}`;

export const ACCOUNT_SUB_PATH = '/account';
export const ACCOUNT_PAGE_URL = `${WORKSPACE_URL_PATTERN}${ACCOUNT_SUB_PATH}`;

export const ORDER_TRACKING_SUB_PATH = '/order-tracking';
export const ORDER_TRACKING_PAGE_URL = `${WORKSPACE_URL_PATTERN}${ORDER_TRACKING_SUB_PATH}`;

export const BILLING_SUB_PATH = '/billing';
export const BILLING_PAGE_URL = `${WORKSPACE_URL_PATTERN}${BILLING_SUB_PATH}`;

export const WORKSPACE_MEMBER_PAGE_URL = `${WORKSPACE_URL_PATTERN}/workspace-member`;

export const SCHEDULE_SUB_PATH = '/schedule';
export const DISPLAY_SCHEDULE_URL = `${WORKSPACE_URL_PATTERN}${SCHEDULE_SUB_PATH}/${DISPLAY_ID_PARAM}`;

export const PROOF_OF_PERFORMANCE_SUB_PATH = '/pop';
export const PROOF_OF_PERFORMANCE_PAGE_URL = `${WORKSPACE_URL_PATTERN}${PROOF_OF_PERFORMANCE_SUB_PATH}`;

export const MY_MEDIA_SUB_PATH = '/mymedia';
export const MY_MEDIA_PAGE_URL = `${WORKSPACE_URL_PATTERN}${MY_MEDIA_SUB_PATH}`;

export const BACK_OFFICE_SUB_PATH = '/back-office';
export const BACK_OFFICE_PAGE_URL = `${WORKSPACE_URL_PATTERN}${BACK_OFFICE_SUB_PATH}`;

export const HELP_PAGE_SUB_PATH = '/help';
export const HELP_PAGE_URL = `${WORKSPACE_URL_PATTERN}${HELP_PAGE_SUB_PATH}`;

export const DOWNLOAD_PLAYER_SUB_PATH = '/downloads';
export const DOWNLOAD_PLAYER_PAGE_URL = `${WORKSPACE_URL_PATTERN}${DOWNLOAD_PLAYER_SUB_PATH}`;

export const MARKETING_SUB_PATH = '/marketing';
export const MARKETING_PAGE_URL = `${WORKSPACE_URL_PATTERN}${MARKETING_SUB_PATH}`;

export const PEOPLE_COUNTER_SUB_PATH = '/people-counter';
export const PEOPLE_COUNTER_PAGE_URL = `${WORKSPACE_URL_PATTERN}${PEOPLE_COUNTER_SUB_PATH}`;

export const CAR_TRACKER_SUB_PATH = '/car-tracker';
export const CAR_TRACKER_PAGE_URL = `${WORKSPACE_URL_PATTERN}${CAR_TRACKER_SUB_PATH}`;

export const VEHICLE_LIST_SUB_PATH = '/vehicle-list';
export const VEHICLE_LIST_ID_PARAM = ':vehicleListId';
export const VEHICLE_LIST_PAGE_URL = `${WORKSPACE_URL_PATTERN}${VEHICLE_LIST_SUB_PATH}`;
export const NEW_VEHICLE_LIST_URL = `${WORKSPACE_URL_PATTERN}${VEHICLE_LIST_SUB_PATH}${NEW_SUB_PATH}`;
export const DERIVE_SUB_PATH = '/derive';
export const DERIVE_VEHICLE_LIST_URL = `${WORKSPACE_URL_PATTERN}${VEHICLE_LIST_SUB_PATH}${DERIVE_SUB_PATH}`;
export const VEHICLE_RECORDS_URL = `${WORKSPACE_URL_PATTERN}${VEHICLE_LIST_SUB_PATH}/${VEHICLE_LIST_ID_PARAM}/records`;

export const DEVICE_MANAGEMENT_SUB_PATH = '/device-management';
export const DEVICE_MANAGEMENT_PAGE_URL = `${WORKSPACE_URL_PATTERN}${DEVICE_MANAGEMENT_SUB_PATH}`;

export const CUSTOMER_DASHBOARD_SUB_PATH = '/dashboard';
export const CUSTOMER_DASHBOARD_URL = `${WORKSPACE_URL_PATTERN}${CUSTOMER_DASHBOARD_SUB_PATH}`;

export const CUSTOMER_DASHBOARD_NOTIFICATIONS_SUB_PATH = '/dashboard/notifications';
export const CUSTOMER_DASHBOARD_NOTIFICATIONS_URL = `${WORKSPACE_URL_PATTERN}${CUSTOMER_DASHBOARD_NOTIFICATIONS_SUB_PATH}`;

export const INVALID_WORKSPACE_URL = '/invalid-workspace';

export const AD_NETWORK_OVERVIEW_SUB_PATH = '/ad-network/overview';
export const AD_NETWORK_OVERVIEW_PAGE_URL = `${WORKSPACE_URL_PATTERN}${AD_NETWORK_OVERVIEW_SUB_PATH}`;
export const AD_NETWORK_PROFILE_SUB_PATH = '/ad-network/profile';
export const AD_NETWORK_PROFILE_PAGE_URL = `${WORKSPACE_URL_PATTERN}${AD_NETWORK_PROFILE_SUB_PATH}`;
export const AD_NETWORK_TERMS_SUB_PATH = '/ad-network/terms';
export const AD_NETWORK_TERMS_PAGE_URL = `${WORKSPACE_URL_PATTERN}${AD_NETWORK_TERMS_SUB_PATH}`;

export const SINGLE_SIGN_ON_URL = '/sso';
